import React from 'react';
import QueryBuilderApp from '../QueryBuilderApp';
import { Button, Row, Col, CardBody, Card, CardHeader } from 'reactstrap';
import Effect from './Effect';
import ErrorMessagesInLang from '../../Configuration/Fields/ErrorMessagesInLang';
import DeleteConfirmation from '../DeleteConfirmation';
export default function Tier({
  tier,
  tIndex,
  duplicateRule,
  deleteRuleHandler,
  updateTierQuery,
  generateId,
  effectTypes,
  discountTypes,
  tiers,
  setTiers,
  duplicateEffect,
  effectChangeHandler,
  tierChangeHandler,
  deleteEffectHandler,
  rewardTypes,
  walletTypes,
  rewardList,
  promotionId,
  draghandleProps,
  enableMilestone,
  partners = [],
}) {
  return (
    <Card className="shadow-none border">
      <CardHeader className="p-0">
        <>
          <Row>
            <Col className="d-flex align-items-center gap-4 justify-content-between">
              <div className="d-flex align-items-center gap-2">
                <i
                  className="bx bx-grid-vertical ms-2 me-2 fs-18"
                  {...draghandleProps}
                ></i>
                <span variant="subtitle2" display="block">
                  {`Rule ${tIndex + 1}`}
                </span>
                <i> of </i>
                <span variant="subtitle2" display="block">
                  {tiers.length}
                </span>
              </div>
              <div className="d-flex flex-row align-items-center gap-2">
                <Button
                  aria-label="duplicate"
                  onClick={() => duplicateRule(tIndex)}
                  id="duplicateRule"
                  size="sm"
                  color="transparent"
                  className="btn px-1 py-1 border-radius-0 shadow-none"
                >
                  <i className="bx bx-copy fs-18"></i>
                </Button>

                <DeleteConfirmation
                  onDelete={() => deleteRuleHandler(tIndex)}
                />
              </div>
            </Col>
          </Row>
        </>
      </CardHeader>
      <CardBody className="border-bottom">
        <Row>
          <Col>
            <label className="fs-14 fw-medium mb-2">Conditions</label>
            <QueryBuilderApp
              updateQuery={(value) => updateTierQuery(value, tIndex)}
              data={tier?.rule}
              fieldGroups={['basket', 'user', 'derived']}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <ErrorMessagesInLang
              value={tier?.conditionErrors || []}
              onChange={(values) => {
                tierChangeHandler(
                  'conditionErrors',
                  values.filter((val) => val.value),
                  tIndex
                );
              }}
            />
          </Col>
        </Row>
      </CardBody>

      <Effect
        tier={tier}
        tIndex={tIndex}
        generateId={generateId}
        effectTypes={effectTypes}
        discountTypes={discountTypes}
        tiers={tiers}
        setTiers={setTiers}
        duplicateEffect={duplicateEffect}
        effectChangeHandler={effectChangeHandler}
        deleteEffectHandler={deleteEffectHandler}
        rewardTypes={rewardTypes}
        walletTypes={walletTypes}
        rewardList={rewardList}
        promotionId={promotionId}
        enableMilestone={enableMilestone}
        partners={partners}
      />
    </Card>
  );
}
